const mock = () => ({
  data: {
    isRegistered: true,
  },
});

export default mock;
